
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groceries",
      function () {
        return require("private-next-pages/groceries.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groceries"])
      });
    }
  